import React from "react";
import { useTranslation } from "react-i18next";

import Row from "components/shared/Row";
import Col from "components/shared/Col";
import HiddenInput from "components/shared/form/HiddenInput";

import PersonalCode from "components/forms/formElements/PersonalCode";
import PhoneNumber from "components/forms/formElements/PhoneNumber";
import Email from "components/forms/formElements/Email";
import MandatoryInputLimited from "components/forms/formElements/MandatoryInputLimited";
import { stripNumbers } from "utils/formUtils";

const SpouseInformationBlock = ({ readOnly = false, formInstance }) => {
  const { t } = useTranslation();

  const setFieldValue = (value, field) => {
    formInstance.setFieldsValue({
      co_applicant: {
        [field]: stripNumbers(value),
      },
    });
  };

  return (
    <>
      <HiddenInput name={["co_applicant", "type"]} />
      <h3 className="leasing-request-form__heading">{t("leasingFormSpouseInformation")}</h3>
      <Row>
        <Col xs={24} sm={12}>
          <MandatoryInputLimited
            label={t("leasingFormSpouseName")}
            name={["co_applicant", "name"]}
            max={30}
            readOnly={readOnly}
            onChange={(value) => setFieldValue(value, "name")}
          />
        </Col>
        <Col xs={24} sm={12}>
          <MandatoryInputLimited
            label={t("leasingFormSpouseSurname")}
            name={["co_applicant", "surname"]}
            max={30}
            readOnly={readOnly}
            onChange={(value) => setFieldValue(value, "surname")}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={12}>
          <PersonalCode
            label={t("leasingFormSpousePersonalCode")}
            name={["co_applicant", "code"]}
            readOnly={readOnly}
          />
        </Col>
        <Col xs={24} sm={12}>
          <PhoneNumber
            form={formInstance}
            label={t("leasingFormSpousePhoneNumber")}
            name={["co_applicant", "phone"]}
            readOnly={readOnly}
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Email label={t("leasingFormSpouseEmail")} name={["co_applicant", "email"]} readOnly={readOnly} />
        </Col>
      </Row>
    </>
  );
};

export default SpouseInformationBlock;
